import * as React from "react";
import { singleton } from "logic/singleton";
const ExportSettingsContext = React.createContext({ settings: {}, setSettings: () => {
} });
export default singleton("contexts.ExportSettingsContext", () => ExportSettingsContext);
